import {defineAsyncComponent} from 'vue';

export const HitCard = defineAsyncComponent(() => import('./HitCard.vue'));
export const HitKpiCard = defineAsyncComponent(
  () => import('./HitKpiCard.vue'),
);
